import Validations from "@/util/Validations.js"

export let hasErrorsValidations = (validations) => {
    return (validations.errors && validations.errors.length) || (validations.fieldErrors && !Validations.isEmpty(validations.fieldErrors))
}